import React from 'react';

const Footer = () => {
    return (
        <div className='text-bg-dark py-2 fixed-bottom text-center'>
            All Rights Reserved @2023
        </div>
    );
};

export default Footer;